<script lang="ts">
    import ApmBoundary from '@shared/components/apm-boundary/ApmBoundary.svelte';
    import { log } from '@shared/log.browser.ts';
    import type { SearchContext } from '@shared/types/types.ts';
    import { injectWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';
    import {
        type WidgetSpinnerData,
        load,
    } from '@tilelist/components/promo-widget-spinner/PromoWidgetSpinner.loader.ts';

    const { html, searchContext }: Partial<WidgetSpinnerData> & { searchContext?: SearchContext } = $props();

    const rule = $derived(searchContext?.rule);

    /*                                           */
    /*                                     */
    let lastRule: string | undefined = html ? rule : undefined;

    let container: HTMLElement | null;

    const wiringCtx = injectWiring();

    /*                                                                      */
    $effect(() => {
        if (!wiringCtx.widgetSpinnerClient || !searchContext?.rule || lastRule === rule) {
            return;
        }
        lastRule = searchContext.rule;
        loadWidgetSpinner(searchContext)
            .then(replaceFragment)
            .catch(() => {
                log.error('Failed to render Widgetspinner');
            });
    });

    function replaceFragment(html: string) {
        if (!container || !html) {
            return;
        }
        /*                                                                                */
        const range = document.createRange();
        range.selectNodeContents(container);
        const fragment = range.createContextualFragment(html);
        range.deleteContents();
        range.insertNode(fragment);
    }

    const loadWidgetSpinner = async (searchContext: SearchContext): Promise<string> => {
        const client = wiringCtx.widgetSpinnerClient;
        if (!client) return '';
        return (await load({ client, searchContext })).html;
    };
</script>

<ApmBoundary scope="promo-widget-spinner">
    <div bind:this={container} id="mas-promo-widgetspinner" class="reptile-tilelist__widgetspinner">
        <!-- for SSR -->
        {@html html || ''}
    </div>
</ApmBoundary>

<style lang="scss">
    .reptile-tilelist__widgetspinner {
        width: 100%;
    }
</style>
